'use strict';

// http interceptor to check auth failures for xhr requests
function ctrl($httpProvider) {
    $httpProvider.interceptors.push('httpInterceptor');
}

ctrl.$inject = ['$httpProvider'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/system/services/httpprovider.js
 **/